const isNaN = (number: unknown): boolean => {
  return typeof number !== "number";
};

export default isNaN;
